/**
 * Utility function to fetch AQI (Air Quality Index), temperature, and UV index data
 * @param {string} sessionId - Session ID for storing data
 * @returns {Promise<Object|null>} AQI data object or null if failed
 */
import { getApiBaseUrl, SALON_API_PREFIX } from './apiConfig';
import { fetchWithTimeout } from './fetchWithTimeout';
import { getCurrentDevicePosition } from '../../shared/deviceGeolocation';
import { setSalonAqiCache } from './salonVisitMemoryCache';

export const fetchAQIData = async (sessionId = null) => {
  // Only fetch if geolocation is supported
  if (!navigator.geolocation) {
    return null;
  }

  const API_BASE_URL = (getApiBaseUrl() || '').replace(/\/$/, '');

  try {
    const position = await getCurrentDevicePosition();
    const latitude = position.latitude;
    const longitude = position.longitude;

    // Fetch AQI data from backend
    const response = await fetchWithTimeout(
      `${API_BASE_URL}${SALON_API_PREFIX}/aqi?latitude=${latitude}&longitude=${longitude}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
        ,
        timeoutMs: 20000,
      }
    );

    const data = await response.json().catch(() => ({}));

    if (response.ok && data.success) {
      // Include lat/lon for storage in skin_environment
      data.latitude = latitude;
      data.longitude = longitude;
      if (sessionId) {
        setSalonAqiCache(sessionId, data);
      }

      return data;
    }

    return null;
  } catch (error) {
    // Silently fail - AQI is optional
    console.warn('Failed to fetch AQI data:', error);
    return null;
  }
};

